import { CustomerUser } from "../../classes";
import Store from "../../store"
const customerUser = {
  namespaced: true,
  state: {
    customerUsers: null,
    isLoading: true
  },
  mutations: {
    setCustomerUsers(state, data) {
      state.customerUsers = data;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    clearCustomerUser(state) {
      state.customerUsers = null;
      state.isLoading = false;
    },
  },
  actions: {
    async getCustomerUserByProject({ commit }, payload) {
      try {
        let user = Store.getters['user/getUser']
        commit("setIsLoading", true);
        commit("setCustomerUsers", null);
        const data = await CustomerUser.getCustomerUserByProject({ projectId: payload }, user ? user : null);
        commit("setCustomerUsers", data || []);
        commit("setIsLoading", false);
        return data;
      } catch (error) {
        commit("setIsLoading", false);
        throw error
      }
    },
  },
  getters: {
    getIsLoading: state => state.isLoading,
    getCustomerUsers: state => state.customerUsers,
    hasCustomerUsers: (state) => {
      return state.customerUsers && state.customerUsers.length > 0 ? true : false
    },
    contracts: (state) => {
      let result = [];
      if (state.customerUsers) {
        for (let customerUser of state.customerUsers) {
          if (customerUser.customer) {
            let contracts = customerUser.customer?.contracts || [];
            let activeContracts = [];
            for (let contract of contracts) {
              if (contract.get("isActive")) activeContracts.push(contract);
            }
            result = [...activeContracts, ...result]
          }
        }
      }
      return result
    },
    contractHistorys: (state) => {
      let result = [];
      if (state.customerUsers) {
        for (let customerUser of state.customerUsers) {
          if (customerUser.customer) {
            let contracts = customerUser.customer?.contracts || [];
            let unActiveContracts = [];
            for (let contract of contracts) {
              if (!contract.get("isActive")) unActiveContracts.push(contract);
            }
            result = [...unActiveContracts, ...result]
          }
        }
      }
      return result
    },
    allContracts: (state) => {
      let result = [];
      if (state.customerUsers) {
        for (let customerUser of state.customerUsers) {
          if (customerUser.customer) {
            let contracts = customerUser.customer?.contracts || [];
            result = [...contracts, ...result]
          }
        }
      }
      return result
    },
    contract: (_, getters) => (id) => {
      let result = null;
      if (id && getters.allContracts && getters.allContracts.length) {
        result = getters.allContracts.find(c => c.id === id)
      }
      return result;
    },
    contractIds: (_, getters) => {
      let result = [];
      let contracts = getters.contracts;
      if (contracts) {
        for (let contract of contracts) {
          result.push(contract.id)
        }

      }
      return result;
    },
    getByCustomer: (state) => (customerId) => {
      if (state.customerUsers) {
        return state.customerUsers.find(d => d.customer && d.customer.id == customerId)
      } else {
        return null
      }
    },
    customers: (state) => {
      let result = [];
      if (state.customerUsers) result = state.customerUsers.map(cu => cu.customer)
      return result
    },
    customerIds: (state) => {
      let result = [];
      if (state.customerUsers) result = state.customerUsers.map(cu => cu.customer.id)
      return result
    },
    markets: (state) => {
      let result = [];
      if (state.customerUsers) {
        for (let customerUser of state.customerUsers) {
          if (customerUser.customer) {
            let contracts = customerUser.customer?.contracts || [];
            for (let contract of contracts) {
              let idx = -1
              if (contract.market && contract.get("isActive")) {
                idx = result.findIndex(mk => mk.id == contract.market.id)
                if (idx < 0) {
                  result.push(contract.market)
                }
              }
            }
          }
        }
      }
      return result
    },
    projects: (state) => {
      let result = [];
      if (state.customerUsers) {
        for (let customerUser of state.customerUsers) {
          if (customerUser.customer) {
            let contracts = customerUser.customer?.contracts || [];
            for (let contract of contracts) {
              let idx = -1
              if (contract.project && contract.get("isActive")) {
                idx = result.findIndex(mk => mk.id == contract.project.id)
                if (idx < 0) {
                  result.push(contract.project)
                }
              }
            }
          }
        }
      }
      return result
    },
  }
};
export default customerUser;
